<template>
  <v-app id="good3" dark>
  <v-content :style="backgroundImageStyle">
    <v-container fluid fill-height>
      <v-layout align-center justify-center row wrap>
        <v-flex id="good3_loginBox" xs12 sm8 lg4 pa-4 elevation-3>
          <v-progress-circular indeterminate color="accent" class="mr-3"></v-progress-circular>
          Loading polymorphic patterns for sprite generation ...
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
  </v-app>
</template>

<script>
// DEFAULT
export default {
  name: 'GOOD3',
  data: () => ({
    backgroundImageStyle: {
      'background-image': 'url(' + require('../assets/wall_old_tristram.jpg') + ')',
      // 'background-image': 'url(' + require('../assets/wall_sea.jpg') + ')',
      'background-size': 'cover',
      'background-position': 'center center',
      'background-repeat': 'no-repeat',
      'background-color': 'grey darken-3'
    }
  })
}
</script>

<style scoped>
#good3_loginBox {
  background-color: #424242a0
}

</style>
